@if(warehouseService.isCompany()){
<app-petcompany></app-petcompany>
}
@if(warehouseService.isShopAndClinic()){
<app-shopandclinic></app-shopandclinic>
}
@if(warehouseService.isWarehouse()){
<app-warehouse></app-warehouse>
}
@if(warehouseService.isShop()){
<app-shop></app-shop>
}
@if(warehouseService.isClinic()){
<app-clinic></app-clinic>
}
@if(warehouseService.isShipping()){
<app-shipping></app-shipping>
}
